import { NgModule, inject } from '@angular/core';
import { TranslateModule, TranslateService, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  imports: [TranslateModule],
  exports: [TranslateModule],
  providers: [
    provideTranslateService({ fallbackLang: 'it' }),
    ...provideTranslateHttpLoader({
      prefix: 'assets/i18n/',
      suffix: '.json',
      useHttpBackend: true,
    }),
  ],
})
export class TranslationModule {
  private readonly translate = inject(TranslateService);

  constructor() {
    this.translate.addLangs(['en', 'it']);
  }
}